import React from 'react'

// styles
import { ContentStylesContainer } from './styles/ContentStyles'

// includes
import Breadcrumbs from './Includes/Breadcrumbs'
import TearmsAndConditions from './Includes/TearmsAndConditions'
import PrivacyPolicy from './Includes/PrivacyPolicy'
import ShippingPolicies from './Includes/ShippingPolicies'
import FAQs from './Includes/FAQs'

export default function Content(props) {
    // props
    const {
        currentRoute
    } = props

    return (
        <ContentStylesContainer>
            <div className="container">
                <Breadcrumbs currentRoute={currentRoute} />
                {/* content */}
                <div className="content">
                    {
                        currentRoute.routeUrl === "about-us" ? (
                            "About Us"
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "faqs" ? (
                            <FAQs />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "terms-and-conditions" ? (
                            <TearmsAndConditions />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "shipping-policy" ? (
                            <ShippingPolicies />
                        ) : null
                    }
                    {
                        currentRoute.routeUrl === "privacy-policy" ? (
                            <PrivacyPolicy />
                        ) : null
                    }
                </div>
            </div>
        </ContentStylesContainer>
    )
}
